import JSEncrypt from 'jsencrypt';
import rsa from "@/rsa/index.json";
	
// rsa加密
export function setJSEncrypt(password) {
	let publicKey = ""
	if(process.env.NODE_ENV === "development") {
		publicKey = rsa.dev
	}else {
		publicKey = rsa.prod
	}
	const encryptor = new JSEncrypt();
	encryptor.setPublicKey(publicKey);
	const encrypted = encryptor.encrypt(password);
	return encrypted
}


// WEBPACK FOOTER //
// ./src/util/index.js